import { automaticReconciliationStatus } from '@/modules/financial/utils/financialHelper'

/**
 * Mesma seleção que `transactionsForConciliateButton` em Reconciliation/index.vue
 * (itens que serão enviados ao clicar em Conciliar).
 */
export default {
  reconciliationQueueForBalancePreview(state) {
    if (!state.isAutomaticReconciliation) return []
    const data = state.importedOFX?.data
    if (!data || !Array.isArray(data)) return []

    const locallyMatchedByImportedId = new Set(
      (state.reconciliationPairingUi?.matchedTransactions || [])
        .map(mt => mt?.imported_transaction?.id)
        .filter(id => id != null && id !== '')
        .map(id => String(id))
    )

    return data.filter(item => {
      const hasSystemTransaction =
        item?.system_transaction &&
        (item.system_transaction.id != null ||
          Object.keys(item.system_transaction).length > 0)
      if (!hasSystemTransaction) return false
      if (item.status === automaticReconciliationStatus.MATCHED) {
        const importedId = item?.imported_transaction?.id
        if (importedId == null || importedId === '') return false
        return locallyMatchedByImportedId.has(String(importedId))
      }
      return true
    })
  }
}
